/**
 * ==========================================================================
 * Rajpura Mixing & Baking - Master Product Recipe Seed Data (71 Products)
 * Contains standard quality targets across all 4 subparts:
 *   1. Ingredient Standard Temperatures (deg C)
 *   2. Raw Material, Syrups & Sponge
 *   3. Mixing & Dough Parameters
 *   4. Baking, Dimensions & Quality Moisture %
 * Mrs. Bectors Food Specialities Ltd. - Rajpura Plant
 * ==========================================================================
 */

export const MB_RECIPES_SEED_DATA: any[] = [
    {
        "id": 901,
        "srNo": 1,
        "title": "Party Cracker",
        "variety": "Party Cracker",
        "sku": [
            "32g",
            "35g",
            "60g",
            "70g",
            "140g",
            "400g"
        ],
        "skuRaw": "(32,35,60,70,140,400)g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 1,
            "variety": "Party Cracker",
            "sku": [
                "32g",
                "35g",
                "60g",
                "70g",
                "140g",
                "400g"
            ],
            "skuRaw": "(32,35,60,70,140,400)g",
            "numberOfBiscuits": 11,
            "dryBiscuitWeight": "32g",
            "gauge": "69±1mm",
            "diameter": "44±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.25%",
            "bakingTime": "4'45\"",
            "weightBeforeOil": "29.72g",
            "weightAfterOil": "32g",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "11",
            "standardsSampleCount": "11",
            "biscuitStdWeight": "32g",
            "biscuitDiameter": "44±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "32g",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "45",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 902,
        "srNo": 2,
        "title": "Bledor Club",
        "variety": "Bledor Club",
        "sku": [
            "25g"
        ],
        "skuRaw": "25",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 2,
            "variety": "Bledor Club",
            "sku": [
                "25g"
            ],
            "skuRaw": "25",
            "numberOfBiscuits": 3,
            "dryBiscuitWeight": "25g",
            "gauge": "13±1mm",
            "diameter": "NA",
            "length": "95±1mm",
            "width": "60±1mm",
            "moisture": "2.00%",
            "bakingTime": "4\"",
            "weightBeforeOil": "23g",
            "weightAfterOil": "25g",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "3",
            "standardsSampleCount": "3",
            "biscuitStdWeight": "25g",
            "biscuitDiameter": "NA",
            "biscuitLength": "95±1mm",
            "biscuitWidth": "60±1mm",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "25g",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "45",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 903,
        "srNo": 3,
        "title": "Zips Cracker",
        "variety": "Zips Cracker",
        "sku": [
            "24g"
        ],
        "skuRaw": "24",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 3,
            "variety": "Zips Cracker",
            "sku": [
                "24g"
            ],
            "skuRaw": "24",
            "numberOfBiscuits": 8,
            "dryBiscuitWeight": "24g",
            "gauge": "40±1mm",
            "diameter": "48±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.25%",
            "bakingTime": "4'40\"",
            "weightBeforeOil": "22.32g",
            "weightAfterOil": "24g",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "8",
            "standardsSampleCount": "8",
            "biscuitStdWeight": "24g",
            "biscuitDiameter": "48±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "24g",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "45",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 904,
        "srNo": 4,
        "title": "Krack Bite",
        "variety": "Krack Bite",
        "sku": [
            "32g",
            "35g",
            "64g",
            "140g"
        ],
        "skuRaw": "(32,35,64,140)g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 4,
            "variety": "Krack Bite",
            "sku": [
                "32g",
                "35g",
                "64g",
                "140g"
            ],
            "skuRaw": "(32,35,64,140)g",
            "numberOfBiscuits": 11,
            "dryBiscuitWeight": "32g",
            "gauge": "68±1mm",
            "diameter": "NA",
            "length": "42±1mm",
            "width": "42±1mm",
            "moisture": "2.25%",
            "bakingTime": "4'45\"",
            "weightBeforeOil": "29.51g",
            "weightAfterOil": "32g",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "11",
            "standardsSampleCount": "11",
            "biscuitStdWeight": "32g",
            "biscuitDiameter": "NA",
            "biscuitLength": "42±1mm",
            "biscuitWidth": "42±1mm",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "32g",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "45",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 905,
        "srNo": 5,
        "title": "Classic Cracker",
        "variety": "Classic Cracker",
        "sku": [
            "120g"
        ],
        "skuRaw": "120g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 5,
            "variety": "Classic Cracker",
            "sku": [
                "120g"
            ],
            "skuRaw": "120g",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "78g",
            "gauge": "69±1mm",
            "diameter": "NA",
            "length": "60+1mm",
            "width": "60+1mm",
            "moisture": "2.25%",
            "bakingTime": "5'50\"",
            "weightBeforeOil": "71.8g",
            "weightAfterOil": "73g",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "78g",
            "biscuitDiameter": "NA",
            "biscuitLength": "60+1mm",
            "biscuitWidth": "60+1mm",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "73g",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "45",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 906,
        "srNo": 6,
        "title": "Sugar Cracker",
        "variety": "Sugar Cracker",
        "sku": [
            "120g"
        ],
        "skuRaw": "120g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 6,
            "variety": "Sugar Cracker",
            "sku": [
                "120g"
            ],
            "skuRaw": "120g",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "78g",
            "gauge": "69±1mm",
            "diameter": "NA",
            "length": "60+1mm",
            "width": "60+1mm",
            "moisture": "2.25%",
            "bakingTime": "5'50\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "78g",
            "biscuitDiameter": "NA",
            "biscuitLength": "60+1mm",
            "biscuitWidth": "60+1mm",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 907,
        "srNo": 7,
        "title": "Taits Round( U Brand, Mini Cracker, Eatz Cracker, Sour Cream, Cheese, Masala)",
        "variety": "Taits Round( U Brand, Mini Cracker, Eatz Cracker, Sour Cream, Cheese, Masala)",
        "sku": [
            "33g"
        ],
        "skuRaw": "33g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 7,
            "variety": "Taits Round( U Brand, Mini Cracker, Eatz Cracker, Sour Cream, Cheese, Masala)",
            "sku": [
                "33g"
            ],
            "skuRaw": "33g",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "10g",
            "gauge": "NA",
            "diameter": "26±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.75%",
            "bakingTime": "5'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "10g",
            "biscuitDiameter": "26±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 908,
        "srNo": 8,
        "title": "Potato Cracker For All Varient",
        "variety": "Potato Cracker For All Varient",
        "sku": [
            "75g"
        ],
        "skuRaw": "75g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 8,
            "variety": "Potato Cracker For All Varient",
            "sku": [
                "75g"
            ],
            "skuRaw": "75g",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "25g",
            "gauge": "25±1mm",
            "diameter": "50±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.75%",
            "bakingTime": "5\"",
            "weightBeforeOil": "22.8g",
            "weightAfterOil": "24.25g",
            "weightWithSeasoning": "25g",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "25g",
            "biscuitDiameter": "50±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "24.25g",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "45",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 909,
        "srNo": 9,
        "title": "Saltine Cracker (12g*48)",
        "variety": "Saltine Cracker (12g*48)",
        "sku": [
            "576g"
        ],
        "skuRaw": "576g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 9,
            "variety": "Saltine Cracker (12g*48)",
            "sku": [
                "576g"
            ],
            "skuRaw": "576g",
            "numberOfBiscuits": "12g",
            "dryBiscuitWeight": "12g",
            "gauge": "14±1mm",
            "diameter": "NA",
            "length": "82±1mm",
            "width": "45±2mm",
            "moisture": "2.00%",
            "bakingTime": "6'00\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "12g",
            "standardsSampleCount": "12g",
            "biscuitStdWeight": "12g",
            "biscuitDiameter": "NA",
            "biscuitLength": "82±1mm",
            "biscuitWidth": "45±2mm",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 910,
        "srNo": 10,
        "title": "Saltine Cracker (Pumpa)",
        "variety": "Saltine Cracker (Pumpa)",
        "sku": [
            "454g"
        ],
        "skuRaw": "454g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 10,
            "variety": "Saltine Cracker (Pumpa)",
            "sku": [
                "454g"
            ],
            "skuRaw": "454g",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "30g",
            "gauge": "50±2mm",
            "diameter": "NA",
            "length": "47±1mm",
            "width": "47±1mm",
            "moisture": "1.75%",
            "bakingTime": "6'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "30g",
            "biscuitDiameter": "NA",
            "biscuitLength": "47±1mm",
            "biscuitWidth": "47±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 911,
        "srNo": 11,
        "title": "Teddy",
        "variety": "Teddy",
        "sku": [
            "25g"
        ],
        "skuRaw": "25g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 11,
            "variety": "Teddy",
            "sku": [
                "25g"
            ],
            "skuRaw": "25g",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "23g",
            "gauge": "NA",
            "diameter": "NA",
            "length": "35±1mm",
            "width": "28±1mm",
            "moisture": "2.00%",
            "bakingTime": "5'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "23g",
            "biscuitDiameter": "NA",
            "biscuitLength": "35±1mm",
            "biscuitWidth": "28±1mm",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 912,
        "srNo": 12,
        "title": "Marie classic",
        "variety": "Marie classic",
        "sku": [
            "9.5g",
            "58.5g",
            "68g",
            "73g",
            "300g",
            "500g"
        ],
        "skuRaw": "(9.5,58.5,68,73,300,500)g",
        "configType": "Product Recipe",
        "productCategory": "Health & Marie",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 12,
            "variety": "Marie classic",
            "sku": [
                "9.5g",
                "58.5g",
                "68g",
                "73g",
                "300g",
                "500g"
            ],
            "skuRaw": "(9.5,58.5,68,73,300,500)g",
            "numberOfBiscuits": 15,
            "dryBiscuitWeight": "73g",
            "gauge": "83±1mm",
            "diameter": "58±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "4\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "15",
            "standardsSampleCount": "15",
            "biscuitStdWeight": "73g",
            "biscuitDiameter": "58±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 913,
        "srNo": 13,
        "title": "Arrowroot",
        "variety": "Arrowroot",
        "sku": [
            "250g"
        ],
        "skuRaw": "250",
        "configType": "Product Recipe",
        "productCategory": "Glucose & Sweet",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 13,
            "variety": "Arrowroot",
            "sku": [
                "250g"
            ],
            "skuRaw": "250",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "84g",
            "gauge": "72±1mm",
            "diameter": "62±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.80%",
            "bakingTime": "4.35\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "84g",
            "biscuitDiameter": "62±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.80%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 914,
        "srNo": 14,
        "title": "Malt",
        "variety": "Malt",
        "sku": [
            "250g"
        ],
        "skuRaw": "250",
        "configType": "Product Recipe",
        "productCategory": "Glucose & Sweet",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 14,
            "variety": "Malt",
            "sku": [
                "250g"
            ],
            "skuRaw": "250",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "84g",
            "gauge": "72±1mm",
            "diameter": "62±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.80%",
            "bakingTime": "4.45\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "84g",
            "biscuitDiameter": "62±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.80%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 915,
        "srNo": 15,
        "title": "Willy Tipo",
        "variety": "Willy Tipo",
        "sku": [
            "33g"
        ],
        "skuRaw": "33",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 15,
            "variety": "Willy Tipo",
            "sku": [
                "33g"
            ],
            "skuRaw": "33",
            "numberOfBiscuits": 4,
            "dryBiscuitWeight": "33g",
            "gauge": "18±1mm",
            "diameter": "NA",
            "length": "95±1mm",
            "width": "58±1mm",
            "moisture": "2.00%",
            "bakingTime": "4'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "4",
            "standardsSampleCount": "4",
            "biscuitStdWeight": "33g",
            "biscuitDiameter": "NA",
            "biscuitLength": "95±1mm",
            "biscuitWidth": "58±1mm",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 916,
        "srNo": 16,
        "title": "Coconut cookies",
        "variety": "Coconut cookies",
        "sku": [
            "31.7g",
            "63.4g"
        ],
        "skuRaw": "(31.7,63.4)g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 16,
            "variety": "Coconut cookies",
            "sku": [
                "31.7g",
                "63.4g"
            ],
            "skuRaw": "(31.7,63.4)g",
            "numberOfBiscuits": 7,
            "dryBiscuitWeight": "31.7g",
            "gauge": "51±1mm",
            "diameter": "44±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "5'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "7",
            "standardsSampleCount": "7",
            "biscuitStdWeight": "31.7g",
            "biscuitDiameter": "44±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 917,
        "srNo": 17,
        "title": "Oatmeal Digestive",
        "variety": "Oatmeal Digestive",
        "sku": [
            "52.5g",
            "105g"
        ],
        "skuRaw": "(52.5,105)g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 17,
            "variety": "Oatmeal Digestive",
            "sku": [
                "52.5g",
                "105g"
            ],
            "skuRaw": "(52.5,105)g",
            "numberOfBiscuits": 14,
            "dryBiscuitWeight": "105g",
            "gauge": "60±1mm",
            "diameter": "52±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "7'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "14",
            "standardsSampleCount": "14",
            "biscuitStdWeight": "105g",
            "biscuitDiameter": "52±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 918,
        "srNo": 18,
        "title": "Jeera lite",
        "variety": "Jeera lite",
        "sku": [
            "35g",
            "39g",
            "70g",
            "74g",
            "140g",
            "146g",
            "156g",
            "486g",
            "500g"
        ],
        "skuRaw": "(35,39,70,74,140,146,156,486,500)g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 18,
            "variety": "Jeera lite",
            "sku": [
                "35g",
                "39g",
                "70g",
                "74g",
                "140g",
                "146g",
                "156g",
                "486g",
                "500g"
            ],
            "skuRaw": "(35,39,70,74,140,146,156,486,500)g",
            "numberOfBiscuits": 17,
            "dryBiscuitWeight": "70g",
            "gauge": "96±1mm",
            "diameter": "41±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "4\"30'",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "17",
            "standardsSampleCount": "17",
            "biscuitStdWeight": "70g",
            "biscuitDiameter": "41±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 919,
        "srNo": 19,
        "title": "Glucose",
        "variety": "Glucose",
        "sku": [
            "26g"
        ],
        "skuRaw": "26g",
        "configType": "Product Recipe",
        "productCategory": "Glucose & Sweet",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 19,
            "variety": "Glucose",
            "sku": [
                "26g"
            ],
            "skuRaw": "26g",
            "numberOfBiscuits": 9,
            "dryBiscuitWeight": "26g",
            "gauge": "56±1mm",
            "diameter": "NA",
            "length": "45+1mm",
            "width": "27+1mm",
            "moisture": "2.00%",
            "bakingTime": "5\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "9",
            "standardsSampleCount": "9",
            "biscuitStdWeight": "26g",
            "biscuitDiameter": "NA",
            "biscuitLength": "45+1mm",
            "biscuitWidth": "27+1mm",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 920,
        "srNo": 20,
        "title": "Golden Bytes Cashew",
        "variety": "Golden Bytes Cashew",
        "sku": [
            "52.9g"
        ],
        "skuRaw": "52.9g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 20,
            "variety": "Golden Bytes Cashew",
            "sku": [
                "52.9g"
            ],
            "skuRaw": "52.9g",
            "numberOfBiscuits": 7,
            "dryBiscuitWeight": "52.9g",
            "gauge": "61±1mm",
            "diameter": "48.5±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "6'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "7",
            "standardsSampleCount": "7",
            "biscuitStdWeight": "52.9g",
            "biscuitDiameter": "48.5±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 921,
        "srNo": 21,
        "title": "Golden Bytes Butter",
        "variety": "Golden Bytes Butter",
        "sku": [
            "68g"
        ],
        "skuRaw": "68g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 21,
            "variety": "Golden Bytes Butter",
            "sku": [
                "68g"
            ],
            "skuRaw": "68g",
            "numberOfBiscuits": 9,
            "dryBiscuitWeight": "68g",
            "gauge": "79±1mm",
            "diameter": "48.5±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "6'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "9",
            "standardsSampleCount": "9",
            "biscuitStdWeight": "68g",
            "biscuitDiameter": "48.5±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 922,
        "srNo": 22,
        "title": "Golden Bytes( 3 lines x68g)",
        "variety": "Golden Bytes( 3 lines x68g)",
        "sku": [
            "200g"
        ],
        "skuRaw": "200g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 22,
            "variety": "Golden Bytes( 3 lines x68g)",
            "sku": [
                "200g"
            ],
            "skuRaw": "200g",
            "numberOfBiscuits": 27,
            "dryBiscuitWeight": "200g",
            "gauge": "79±1mm",
            "diameter": "48.5±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "6'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "27",
            "standardsSampleCount": "27",
            "biscuitStdWeight": "200g",
            "biscuitDiameter": "48.5±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 923,
        "srNo": 23,
        "title": "Golden Bytes(100x5)",
        "variety": "Golden Bytes(100x5)",
        "sku": [
            "500g"
        ],
        "skuRaw": "500g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 23,
            "variety": "Golden Bytes(100x5)",
            "sku": [
                "500g"
            ],
            "skuRaw": "500g",
            "numberOfBiscuits": 13,
            "dryBiscuitWeight": "100g",
            "gauge": "110±2mm",
            "diameter": "48.5±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "6'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "13",
            "standardsSampleCount": "13",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "48.5±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 924,
        "srNo": 24,
        "title": "Premium Butter Cookies",
        "variety": "Premium Butter Cookies",
        "sku": [
            "100g"
        ],
        "skuRaw": "100g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 24,
            "variety": "Premium Butter Cookies",
            "sku": [
                "100g"
            ],
            "skuRaw": "100g",
            "numberOfBiscuits": 18,
            "dryBiscuitWeight": "100g",
            "gauge": "138±2mm",
            "diameter": "46±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "5'50\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "18",
            "standardsSampleCount": "18",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "46±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 925,
        "srNo": 25,
        "title": "Kaju khajoor",
        "variety": "Kaju khajoor",
        "sku": [
            "100g"
        ],
        "skuRaw": "100g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 25,
            "variety": "Kaju khajoor",
            "sku": [
                "100g"
            ],
            "skuRaw": "100g",
            "numberOfBiscuits": 18,
            "dryBiscuitWeight": "100g",
            "gauge": "138±2mm",
            "diameter": "46±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "5'50\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "18",
            "standardsSampleCount": "18",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "46±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 926,
        "srNo": 26,
        "title": "Milkyz",
        "variety": "Milkyz",
        "sku": [
            "33.5g"
        ],
        "skuRaw": "33.5g",
        "configType": "Product Recipe",
        "productCategory": "Glucose & Sweet",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 26,
            "variety": "Milkyz",
            "sku": [
                "33.5g"
            ],
            "skuRaw": "33.5g",
            "numberOfBiscuits": 7,
            "dryBiscuitWeight": "33.5g",
            "gauge": "46±2mm",
            "diameter": "NA",
            "length": "54±1mm",
            "width": "34±1mm",
            "moisture": "1.50%",
            "bakingTime": "6\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "7",
            "standardsSampleCount": "7",
            "biscuitStdWeight": "33.5g",
            "biscuitDiameter": "NA",
            "biscuitLength": "54±1mm",
            "biscuitWidth": "34±1mm",
            "moistureStandard": "1.50%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 927,
        "srNo": 27,
        "title": "Teddy",
        "variety": "Teddy",
        "sku": [
            "26g"
        ],
        "skuRaw": "26g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 27,
            "variety": "Teddy",
            "sku": [
                "26g"
            ],
            "skuRaw": "26g",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "26g",
            "gauge": "NA",
            "diameter": "NA",
            "length": "35±1mm",
            "width": "28±1mm",
            "moisture": "2.00%",
            "bakingTime": "5'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "26g",
            "biscuitDiameter": "NA",
            "biscuitLength": "35±1mm",
            "biscuitWidth": "28±1mm",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 928,
        "srNo": 28,
        "title": "Numeric",
        "variety": "Numeric",
        "sku": [
            "25g"
        ],
        "skuRaw": "25g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 28,
            "variety": "Numeric",
            "sku": [
                "25g"
            ],
            "skuRaw": "25g",
            "numberOfBiscuits": 11,
            "dryBiscuitWeight": "25g",
            "gauge": "NA",
            "diameter": "NA",
            "length": "26±1mm",
            "width": "26±1mm",
            "moisture": "1.75%",
            "bakingTime": "5'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "11",
            "standardsSampleCount": "11",
            "biscuitStdWeight": "25g",
            "biscuitDiameter": "NA",
            "biscuitLength": "26±1mm",
            "biscuitWidth": "26±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 929,
        "srNo": 29,
        "title": "Alphabte Cookies",
        "variety": "Alphabte Cookies",
        "sku": [
            "25g"
        ],
        "skuRaw": "25g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 29,
            "variety": "Alphabte Cookies",
            "sku": [
                "25g"
            ],
            "skuRaw": "25g",
            "numberOfBiscuits": 11,
            "dryBiscuitWeight": "25g",
            "gauge": "NA",
            "diameter": "NA",
            "length": "26±1mm",
            "width": "26±1mm",
            "moisture": "1.75%",
            "bakingTime": "5'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "11",
            "standardsSampleCount": "11",
            "biscuitStdWeight": "25g",
            "biscuitDiameter": "NA",
            "biscuitLength": "26±1mm",
            "biscuitWidth": "26±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 930,
        "srNo": 30,
        "title": "Double Delight/Cashew Delight",
        "variety": "Double Delight/Cashew Delight",
        "sku": [
            "64g"
        ],
        "skuRaw": "64g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 30,
            "variety": "Double Delight/Cashew Delight",
            "sku": [
                "64g"
            ],
            "skuRaw": "64g",
            "numberOfBiscuits": 9,
            "dryBiscuitWeight": "64g",
            "gauge": "78±2mm",
            "diameter": "48±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.75%",
            "bakingTime": "6'20\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "9",
            "standardsSampleCount": "9",
            "biscuitStdWeight": "64g",
            "biscuitDiameter": "48±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 931,
        "srNo": 31,
        "title": "NS Kalonji Cracker",
        "variety": "NS Kalonji Cracker",
        "sku": [
            "71.2g"
        ],
        "skuRaw": "71.2g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 31,
            "variety": "NS Kalonji Cracker",
            "sku": [
                "71.2g"
            ],
            "skuRaw": "71.2g",
            "numberOfBiscuits": 20,
            "dryBiscuitWeight": "71.2g",
            "gauge": "102±2mm",
            "diameter": "NA",
            "length": "60±1mm",
            "width": "38±1mm",
            "moisture": "1.50%",
            "bakingTime": "4'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "20",
            "standardsSampleCount": "20",
            "biscuitStdWeight": "71.2g",
            "biscuitDiameter": "NA",
            "biscuitLength": "60±1mm",
            "biscuitWidth": "38±1mm",
            "moistureStandard": "1.50%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 932,
        "srNo": 32,
        "title": "Digestive Cracker",
        "variety": "Digestive Cracker",
        "sku": [
            "64g"
        ],
        "skuRaw": "64g",
        "configType": "Product Recipe",
        "productCategory": "Crackers",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 32,
            "variety": "Digestive Cracker",
            "sku": [
                "64g"
            ],
            "skuRaw": "64g",
            "numberOfBiscuits": 9,
            "dryBiscuitWeight": "64g",
            "gauge": "57±1mm",
            "diameter": "53±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.50%",
            "bakingTime": "6'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "9",
            "standardsSampleCount": "9",
            "biscuitStdWeight": "64g",
            "biscuitDiameter": "53±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.50%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 933,
        "srNo": 33,
        "title": "Digestive Export",
        "variety": "Digestive Export",
        "sku": [
            "120g"
        ],
        "skuRaw": "120g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 33,
            "variety": "Digestive Export",
            "sku": [
                "120g"
            ],
            "skuRaw": "120g",
            "numberOfBiscuits": 17,
            "dryBiscuitWeight": "120g",
            "gauge": "102±1mm",
            "diameter": "53±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.50%",
            "bakingTime": "6'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "17",
            "standardsSampleCount": "17",
            "biscuitStdWeight": "120g",
            "biscuitDiameter": "53±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.50%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 934,
        "srNo": 34,
        "title": "Digestive Export",
        "variety": "Digestive Export",
        "sku": [
            "250g"
        ],
        "skuRaw": "250g",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 34,
            "variety": "Digestive Export",
            "sku": [
                "250g"
            ],
            "skuRaw": "250g",
            "numberOfBiscuits": 18,
            "dryBiscuitWeight": "250g",
            "gauge": "125±1mm",
            "diameter": "67±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.50%",
            "bakingTime": "6'30\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "18",
            "standardsSampleCount": "18",
            "biscuitStdWeight": "250g",
            "biscuitDiameter": "67±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.50%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 935,
        "srNo": 35,
        "title": "Pista Almond",
        "variety": "Pista Almond",
        "sku": [
            "75g"
        ],
        "skuRaw": "75",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 35,
            "variety": "Pista Almond",
            "sku": [
                "75g"
            ],
            "skuRaw": "75",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "75g",
            "gauge": "90±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "9''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "75g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 936,
        "srNo": 36,
        "title": "Pista Almond",
        "variety": "Pista Almond",
        "sku": [
            "100g"
        ],
        "skuRaw": "100",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 36,
            "variety": "Pista Almond",
            "sku": [
                "100g"
            ],
            "skuRaw": "100",
            "numberOfBiscuits": 13,
            "dryBiscuitWeight": "100g",
            "gauge": "117±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "NA",
            "bakingTime": "NA",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "13",
            "standardsSampleCount": "13",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "NA",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 937,
        "srNo": 37,
        "title": "Fruit & Nuts",
        "variety": "Fruit & Nuts",
        "sku": [
            "75g"
        ],
        "skuRaw": "75",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 37,
            "variety": "Fruit & Nuts",
            "sku": [
                "75g"
            ],
            "skuRaw": "75",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "75g",
            "gauge": "90±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "9''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "75g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 938,
        "srNo": 38,
        "title": "Fruit & Nuts",
        "variety": "Fruit & Nuts",
        "sku": [
            "100g"
        ],
        "skuRaw": "100",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 38,
            "variety": "Fruit & Nuts",
            "sku": [
                "100g"
            ],
            "skuRaw": "100",
            "numberOfBiscuits": 13,
            "dryBiscuitWeight": "100g",
            "gauge": "117±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "NA",
            "bakingTime": "NA",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "13",
            "standardsSampleCount": "13",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "NA",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 939,
        "srNo": 39,
        "title": "Chocochips",
        "variety": "Chocochips",
        "sku": [
            "75g"
        ],
        "skuRaw": "75",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 39,
            "variety": "Chocochips",
            "sku": [
                "75g"
            ],
            "skuRaw": "75",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "75g",
            "gauge": "90±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "9''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "75g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 940,
        "srNo": 40,
        "title": "Chocochips",
        "variety": "Chocochips",
        "sku": [
            "100g"
        ],
        "skuRaw": "100",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 40,
            "variety": "Chocochips",
            "sku": [
                "100g"
            ],
            "skuRaw": "100",
            "numberOfBiscuits": 13,
            "dryBiscuitWeight": "100g",
            "gauge": "117±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "NA",
            "bakingTime": "NA",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "13",
            "standardsSampleCount": "13",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "NA",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 941,
        "srNo": 41,
        "title": "Choco Ruffle",
        "variety": "Choco Ruffle",
        "sku": [
            "75g"
        ],
        "skuRaw": "75",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 41,
            "variety": "Choco Ruffle",
            "sku": [
                "75g"
            ],
            "skuRaw": "75",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "75g",
            "gauge": "90±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "9''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "75g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 942,
        "srNo": 42,
        "title": "Honey Oatmeal",
        "variety": "Honey Oatmeal",
        "sku": [
            "75g"
        ],
        "skuRaw": "75",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 42,
            "variety": "Honey Oatmeal",
            "sku": [
                "75g"
            ],
            "skuRaw": "75",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "75g",
            "gauge": "90±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "9''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "75g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 943,
        "srNo": 43,
        "title": "Honey Oatmeal",
        "variety": "Honey Oatmeal",
        "sku": [
            "100g"
        ],
        "skuRaw": "100",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 43,
            "variety": "Honey Oatmeal",
            "sku": [
                "100g"
            ],
            "skuRaw": "100",
            "numberOfBiscuits": 13,
            "dryBiscuitWeight": "100g",
            "gauge": "117±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "NA",
            "bakingTime": "NA",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "13",
            "standardsSampleCount": "13",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "NA",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 944,
        "srNo": 44,
        "title": "Chip of Joy",
        "variety": "Chip of Joy",
        "sku": [
            "100g"
        ],
        "skuRaw": "100",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 44,
            "variety": "Chip of Joy",
            "sku": [
                "100g"
            ],
            "skuRaw": "100",
            "numberOfBiscuits": 9,
            "dryBiscuitWeight": "100g",
            "gauge": "92±2mm",
            "diameter": "54±2mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "11''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "9",
            "standardsSampleCount": "9",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "54±2mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 945,
        "srNo": 45,
        "title": "Chip of Joy",
        "variety": "Chip of Joy",
        "sku": [
            "163g"
        ],
        "skuRaw": "163",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 45,
            "variety": "Chip of Joy",
            "sku": [
                "163g"
            ],
            "skuRaw": "163",
            "numberOfBiscuits": 16,
            "dryBiscuitWeight": "163g",
            "gauge": "92±2mm",
            "diameter": "54±2mm",
            "length": "NA",
            "width": "NA",
            "moisture": "NA",
            "bakingTime": "NA",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "16",
            "standardsSampleCount": "16",
            "biscuitStdWeight": "163g",
            "biscuitDiameter": "54±2mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "NA",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 946,
        "srNo": 46,
        "title": "Trufills SD/DD",
        "variety": "Trufills SD/DD",
        "sku": [
            "75g"
        ],
        "skuRaw": "75",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 46,
            "variety": "Trufills SD/DD",
            "sku": [
                "75g"
            ],
            "skuRaw": "75",
            "numberOfBiscuits": 6,
            "dryBiscuitWeight": "75g",
            "gauge": "120±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.25%",
            "bakingTime": "12''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "6",
            "standardsSampleCount": "6",
            "biscuitStdWeight": "75g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 947,
        "srNo": 47,
        "title": "Trufills SD/DD",
        "variety": "Trufills SD/DD",
        "sku": [
            "100g"
        ],
        "skuRaw": "100",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 47,
            "variety": "Trufills SD/DD",
            "sku": [
                "100g"
            ],
            "skuRaw": "100",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "100g",
            "gauge": "105±2mm",
            "diameter": "45±2mm",
            "length": "NA",
            "width": "NA",
            "moisture": "NA",
            "bakingTime": "NA",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "100g",
            "biscuitDiameter": "45±2mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "NA",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 948,
        "srNo": 48,
        "title": "Trufills SD/DD",
        "variety": "Trufills SD/DD",
        "sku": [
            "75g"
        ],
        "skuRaw": "75",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 48,
            "variety": "Trufills SD/DD",
            "sku": [
                "75g"
            ],
            "skuRaw": "75",
            "numberOfBiscuits": 6,
            "dryBiscuitWeight": "75g",
            "gauge": "120±2mm",
            "diameter": "47±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "NA",
            "bakingTime": "NA",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "6",
            "standardsSampleCount": "6",
            "biscuitStdWeight": "75g",
            "biscuitDiameter": "47±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "NA",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 949,
        "srNo": 49,
        "title": "Ginger Cookies (Thins)",
        "variety": "Ginger Cookies (Thins)",
        "sku": [
            "150g"
        ],
        "skuRaw": "150",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 49,
            "variety": "Ginger Cookies (Thins)",
            "sku": [
                "150g"
            ],
            "skuRaw": "150",
            "numberOfBiscuits": 27,
            "dryBiscuitWeight": "150g",
            "gauge": "45±2mm",
            "diameter": "53±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "1.50%",
            "bakingTime": "11''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "27",
            "standardsSampleCount": "27",
            "biscuitStdWeight": "150g",
            "biscuitDiameter": "53±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "1.50%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 950,
        "srNo": 50,
        "title": "Shortbread",
        "variety": "Shortbread",
        "sku": [
            "85g"
        ],
        "skuRaw": "85",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 50,
            "variety": "Shortbread",
            "sku": [
                "85g"
            ],
            "skuRaw": "85",
            "numberOfBiscuits": 5,
            "dryBiscuitWeight": "85g",
            "gauge": "145±2mm",
            "diameter": "NA",
            "length": "74±2mm",
            "width": "28±2mm",
            "moisture": "2.75%",
            "bakingTime": "16''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "5",
            "standardsSampleCount": "5",
            "biscuitStdWeight": "85g",
            "biscuitDiameter": "NA",
            "biscuitLength": "74±2mm",
            "biscuitWidth": "28±2mm",
            "moistureStandard": "2.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 951,
        "srNo": 51,
        "title": "Mini Chocochip",
        "variety": "Mini Chocochip",
        "sku": [
            "125g"
        ],
        "skuRaw": "125",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 51,
            "variety": "Mini Chocochip",
            "sku": [
                "125g"
            ],
            "skuRaw": "125",
            "numberOfBiscuits": 32,
            "dryBiscuitWeight": "125g",
            "gauge": "NA",
            "diameter": "33±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "9''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "32",
            "standardsSampleCount": "32",
            "biscuitStdWeight": "125g",
            "biscuitDiameter": "33±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 952,
        "srNo": 52,
        "title": "Caramelised",
        "variety": "Caramelised",
        "sku": [
            "83g"
        ],
        "skuRaw": "83",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 52,
            "variety": "Caramelised",
            "sku": [
                "83g"
            ],
            "skuRaw": "83",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "83g",
            "gauge": "61±1mm",
            "diameter": "NA",
            "length": "72±1mm",
            "width": "34±1mm",
            "moisture": "2.25%",
            "bakingTime": "10''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "83g",
            "biscuitDiameter": "NA",
            "biscuitLength": "72±1mm",
            "biscuitWidth": "34±1mm",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 953,
        "srNo": 53,
        "title": "Scotch Finger",
        "variety": "Scotch Finger",
        "sku": [
            "180g"
        ],
        "skuRaw": "180",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 53,
            "variety": "Scotch Finger",
            "sku": [
                "180g"
            ],
            "skuRaw": "180",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "180g",
            "gauge": "102±1mm",
            "diameter": "NA",
            "length": "75±1mm",
            "width": "43±1mm",
            "moisture": "2.75%",
            "bakingTime": "18''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "180g",
            "biscuitDiameter": "NA",
            "biscuitLength": "75±1mm",
            "biscuitWidth": "43±1mm",
            "moistureStandard": "2.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 954,
        "srNo": 54,
        "title": "Gingernut",
        "variety": "Gingernut",
        "sku": [
            "147g"
        ],
        "skuRaw": "147",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 54,
            "variety": "Gingernut",
            "sku": [
                "147g"
            ],
            "skuRaw": "147",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "147g",
            "gauge": "96±1mm",
            "diameter": "57±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.25%",
            "bakingTime": "14''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "147g",
            "biscuitDiameter": "57±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 955,
        "srNo": 55,
        "title": "Chocochips",
        "variety": "Chocochips",
        "sku": [
            "111g"
        ],
        "skuRaw": "111",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 55,
            "variety": "Chocochips",
            "sku": [
                "111g"
            ],
            "skuRaw": "111",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "111g",
            "gauge": "92±2mm",
            "diameter": "54±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.25%",
            "bakingTime": "12''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "111g",
            "biscuitDiameter": "54±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.25%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 956,
        "srNo": 56,
        "title": "Vanilla",
        "variety": "Vanilla",
        "sku": [
            "104g"
        ],
        "skuRaw": "104",
        "configType": "Product Recipe",
        "productCategory": "Cream",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 56,
            "variety": "Vanilla",
            "sku": [
                "104g"
            ],
            "skuRaw": "104",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "104g",
            "gauge": "67±2mm",
            "diameter": "63±1mm",
            "length": "NA",
            "width": "NA",
            "moisture": "2.00%",
            "bakingTime": "10''",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "104g",
            "biscuitDiameter": "63±1mm",
            "biscuitLength": "NA",
            "biscuitWidth": "NA",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 957,
        "srNo": 57,
        "title": "Chelsea",
        "variety": "Chelsea",
        "sku": [
            "30g"
        ],
        "skuRaw": "30",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 57,
            "variety": "Chelsea",
            "sku": [
                "30g"
            ],
            "skuRaw": "30",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "27g",
            "gauge": "44±1mm",
            "diameter": "NA",
            "length": "42±1mm",
            "width": "42±1mm",
            "moisture": "1.75%",
            "bakingTime": "5'3\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "27g",
            "biscuitDiameter": "NA",
            "biscuitLength": "42±1mm",
            "biscuitWidth": "42±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 958,
        "srNo": 58,
        "title": "U Brand",
        "variety": "U Brand",
        "sku": [
            "30g"
        ],
        "skuRaw": "30",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 58,
            "variety": "U Brand",
            "sku": [
                "30g"
            ],
            "skuRaw": "30",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "27g",
            "gauge": "44±1mm",
            "diameter": "NA",
            "length": "42±1mm",
            "width": "42±1mm",
            "moisture": "1.75%",
            "bakingTime": "5'3\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "27g",
            "biscuitDiameter": "NA",
            "biscuitLength": "42±1mm",
            "biscuitWidth": "42±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 959,
        "srNo": 59,
        "title": "Nice Crunch",
        "variety": "Nice Crunch",
        "sku": [
            "150g"
        ],
        "skuRaw": "150",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 59,
            "variety": "Nice Crunch",
            "sku": [
                "150g"
            ],
            "skuRaw": "150",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "35g",
            "gauge": "53±1mm",
            "diameter": "NA",
            "length": "42±1mm",
            "width": "42±1mm",
            "moisture": "1.75%",
            "bakingTime": "5'3\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "35g",
            "biscuitDiameter": "NA",
            "biscuitLength": "42±1mm",
            "biscuitWidth": "42±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 960,
        "srNo": 60,
        "title": "Melto",
        "variety": "Melto",
        "sku": [
            "50g",
            "100g",
            "300g"
        ],
        "skuRaw": "50,100,300",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 60,
            "variety": "Melto",
            "sku": [
                "50g",
                "100g",
                "300g"
            ],
            "skuRaw": "50,100,300",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "35g",
            "gauge": "51±1mm",
            "diameter": "NA",
            "length": "42±1mm",
            "width": "42±1mm",
            "moisture": "1.75%",
            "bakingTime": "5'3\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "35g",
            "biscuitDiameter": "NA",
            "biscuitLength": "42±1mm",
            "biscuitWidth": "42±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 961,
        "srNo": 61,
        "title": "Trio 4",
        "variety": "Trio 4",
        "sku": [
            "28g",
            "42g"
        ],
        "skuRaw": "28,42",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 61,
            "variety": "Trio 4",
            "sku": [
                "28g",
                "42g"
            ],
            "skuRaw": "28,42",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "27g",
            "gauge": "44±1mm",
            "diameter": "NA",
            "length": "42±1mm",
            "width": "42±1mm",
            "moisture": "1.75%",
            "bakingTime": "5'3\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "27g",
            "biscuitDiameter": "NA",
            "biscuitLength": "42±1mm",
            "biscuitWidth": "42±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 962,
        "srNo": 62,
        "title": "Butter Cookies",
        "variety": "Butter Cookies",
        "sku": [
            "33g"
        ],
        "skuRaw": "33",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 62,
            "variety": "Butter Cookies",
            "sku": [
                "33g"
            ],
            "skuRaw": "33",
            "numberOfBiscuits": 7,
            "dryBiscuitWeight": "33g",
            "gauge": "53±1mm",
            "diameter": "NA",
            "length": "44±1mm",
            "width": "44±1mm",
            "moisture": "2.00%",
            "bakingTime": "4'2\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "7",
            "standardsSampleCount": "7",
            "biscuitStdWeight": "33g",
            "biscuitDiameter": "NA",
            "biscuitLength": "44±1mm",
            "biscuitWidth": "44±1mm",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 963,
        "srNo": 63,
        "title": "Cashew Cookies",
        "variety": "Cashew Cookies",
        "sku": [
            "33g"
        ],
        "skuRaw": "33",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 63,
            "variety": "Cashew Cookies",
            "sku": [
                "33g"
            ],
            "skuRaw": "33",
            "numberOfBiscuits": 7,
            "dryBiscuitWeight": "33g",
            "gauge": "53±1mm",
            "diameter": "NA",
            "length": "44±1mm",
            "width": "44±1mm",
            "moisture": "2.00%",
            "bakingTime": "4'2\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "7",
            "standardsSampleCount": "7",
            "biscuitStdWeight": "33g",
            "biscuitDiameter": "NA",
            "biscuitLength": "44±1mm",
            "biscuitWidth": "44±1mm",
            "moistureStandard": "2.00%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 964,
        "srNo": 64,
        "title": "Bourbon",
        "variety": "Bourbon",
        "sku": [
            "65g"
        ],
        "skuRaw": "65",
        "configType": "Product Recipe",
        "productCategory": "Cream",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 64,
            "variety": "Bourbon",
            "sku": [
                "65g"
            ],
            "skuRaw": "65",
            "numberOfBiscuits": 14,
            "dryBiscuitWeight": "49g",
            "gauge": "74±1mm",
            "diameter": "NA",
            "length": "55±1mm",
            "width": "25±1mm",
            "moisture": "1.50%",
            "bakingTime": "6\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "14",
            "standardsSampleCount": "14",
            "biscuitStdWeight": "49g",
            "biscuitDiameter": "NA",
            "biscuitLength": "55±1mm",
            "biscuitWidth": "25±1mm",
            "moistureStandard": "1.50%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 965,
        "srNo": 65,
        "title": "Bourbon CSD",
        "variety": "Bourbon CSD",
        "sku": [
            "100g"
        ],
        "skuRaw": "100",
        "configType": "Product Recipe",
        "productCategory": "Cream",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 65,
            "variety": "Bourbon CSD",
            "sku": [
                "100g"
            ],
            "skuRaw": "100",
            "numberOfBiscuits": 16,
            "dryBiscuitWeight": "77g",
            "gauge": "92±2mm",
            "diameter": "NA",
            "length": "63±1mm",
            "width": "25±1mm",
            "moisture": "1.50%",
            "bakingTime": "6\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "16",
            "standardsSampleCount": "16",
            "biscuitStdWeight": "77g",
            "biscuitDiameter": "NA",
            "biscuitLength": "63±1mm",
            "biscuitWidth": "25±1mm",
            "moistureStandard": "1.50%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 966,
        "srNo": 66,
        "title": "Choco Bico",
        "variety": "Choco Bico",
        "sku": [
            "40g"
        ],
        "skuRaw": "40",
        "configType": "Product Recipe",
        "productCategory": "Cookies",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 66,
            "variety": "Choco Bico",
            "sku": [
                "40g"
            ],
            "skuRaw": "40",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "40g",
            "gauge": "75±1mm",
            "diameter": "NA",
            "length": "35.5±1mm",
            "width": "35.5±1mm",
            "moisture": "1.75%",
            "bakingTime": "5\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "40g",
            "biscuitDiameter": "NA",
            "biscuitLength": "35.5±1mm",
            "biscuitWidth": "35.5±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 967,
        "srNo": 67,
        "title": "Biskwi",
        "variety": "Biskwi",
        "sku": [
            "300g"
        ],
        "skuRaw": "300",
        "configType": "Product Recipe",
        "productCategory": "Cream",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 67,
            "variety": "Biskwi",
            "sku": [
                "300g"
            ],
            "skuRaw": "300",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "39g",
            "gauge": "59±1mm",
            "diameter": "NA",
            "length": "44±1mm",
            "width": "44±1mm",
            "moisture": "1.75%",
            "bakingTime": "5\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "39g",
            "biscuitDiameter": "NA",
            "biscuitLength": "44±1mm",
            "biscuitWidth": "44±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 968,
        "srNo": 68,
        "title": "Cream Biscuits",
        "variety": "Cream Biscuits",
        "sku": [
            "414g"
        ],
        "skuRaw": "414",
        "configType": "Product Recipe",
        "productCategory": "Cream",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 68,
            "variety": "Cream Biscuits",
            "sku": [
                "414g"
            ],
            "skuRaw": "414",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "39g",
            "gauge": "59±1mm",
            "diameter": "NA",
            "length": "44±1mm",
            "width": "44±1mm",
            "moisture": "1.75%",
            "bakingTime": "5\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "39g",
            "biscuitDiameter": "NA",
            "biscuitLength": "44±1mm",
            "biscuitWidth": "44±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 969,
        "srNo": 69,
        "title": "Clover Valley",
        "variety": "Clover Valley",
        "sku": [
            "334g"
        ],
        "skuRaw": "334",
        "configType": "Product Recipe",
        "productCategory": "Cream",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 69,
            "variety": "Clover Valley",
            "sku": [
                "334g"
            ],
            "skuRaw": "334",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "38g",
            "gauge": "59±1mm",
            "diameter": "NA",
            "length": "44±1mm",
            "width": "44±1mm",
            "moisture": "1.75%",
            "bakingTime": "5\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "38g",
            "biscuitDiameter": "NA",
            "biscuitLength": "44±1mm",
            "biscuitWidth": "44±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 970,
        "srNo": 70,
        "title": "Jumbo Cream",
        "variety": "Jumbo Cream",
        "sku": [
            "45g"
        ],
        "skuRaw": "45",
        "configType": "Product Recipe",
        "productCategory": "Cream",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 70,
            "variety": "Jumbo Cream",
            "sku": [
                "45g"
            ],
            "skuRaw": "45",
            "numberOfBiscuits": 12,
            "dryBiscuitWeight": "34.6g",
            "gauge": "63±1mm",
            "diameter": "NA",
            "length": "40±1mm",
            "width": "40±1mm",
            "moisture": "1.75%",
            "bakingTime": "5\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "12",
            "standardsSampleCount": "12",
            "biscuitStdWeight": "34.6g",
            "biscuitDiameter": "NA",
            "biscuitLength": "40±1mm",
            "biscuitWidth": "40±1mm",
            "moistureStandard": "1.75%",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    },
    {
        "id": 971,
        "srNo": 71,
        "title": "Premium Cream",
        "variety": "Premium Cream",
        "sku": [
            "46g"
        ],
        "skuRaw": "46",
        "configType": "Product Recipe",
        "productCategory": "Cream",
        "plant": "Rajpura",
        "isActive": true,
        "standards": {
            "srNo": 71,
            "variety": "Premium Cream",
            "sku": [
                "46g"
            ],
            "skuRaw": "46",
            "numberOfBiscuits": 10,
            "dryBiscuitWeight": "39.2g",
            "gauge": "65±2mm",
            "diameter": "NA",
            "length": "46±1mm",
            "width": "46±1mm",
            "moisture": "—",
            "bakingTime": "5\"",
            "weightBeforeOil": "NA",
            "weightAfterOil": "NA",
            "weightWithSeasoning": "NA",
            "formingSampleCount": "10",
            "standardsSampleCount": "10",
            "biscuitStdWeight": "39.2g",
            "biscuitDiameter": "NA",
            "biscuitLength": "46±1mm",
            "biscuitWidth": "46±1mm",
            "moistureStandard": "—",
            "weightAfterOilSpray": "NA",
            "bakingProfileAsPerTemplate": true,
            "topColourStandard": "As per std",
            "topColourObserved": "As per std",
            "bottomColourStandard": "As per std",
            "bottomColourObserved": "As per std",
            "rpoStandard": "NA",
            "solidFatStandard": "NA",
            "butterStandard": "NA",
            "blackJackStandard": "NA",
            "spongeTempStandard": "NA",
            "slurryStandard": "NA",
            "groundSugarTempStandard": "NA",
            "groundSugarParticleSizeStandard": "NA",
            "creamingTimeStandard": "10 min",
            "mixingTimeStandard": "5 Min",
            "doughTempStandard": "32-35",
            "doughStandingTimeStandard": "10 Min",
            "standardWetWeight": "NA"
        }
    }
];

// Self-export for both standard browser script tag and window global namespace
if (typeof window !== "undefined") {
    (window as any).MB_RECIPES_SEED_DATA = MB_RECIPES_SEED_DATA;
}

export default MB_RECIPES_SEED_DATA;


